'use client';

import { Link } from '@curology/ui-components-web/react/Link';
import { useMemo } from 'react';

import { type Brand } from '@/consts/brands';
import { DATA_KEYS } from '@/consts/dataKeys';
import { urls } from '@/utils/urls';

import { useFlowContext } from '../../hooks/useFlowContext';
import { useFlowUrl } from '../../hooks/useFlowUrl';
import { useDataProvider } from '../DataProvider/useDataProvider';

const brandMap: Record<Brand, string> = {
  curology: 'a Curology',
  agency: 'an Agency',
};

export const LoginSection = () => {
  const { brand } = useFlowContext();
  const isAuthenticated = useDataProvider(DATA_KEYS.isAuthenticated);
  const redirectUrl = useFlowUrl({ type: 'absolutePath' });

  const loginUrl = useMemo(() => {
    const loginUrl = new URL(urls[brand].legacy.auth.login);
    loginUrl.searchParams.append('signupRedirect', redirectUrl);
    return loginUrl;
  }, [brand, redirectUrl]);

  if (isAuthenticated) {
    return null;
  }

  return (
    <div className="cur-max-w-[328px]">
      Already have {brandMap[brand]} account?{' '}
      <Link href={loginUrl.toString()}>Log in</Link>
    </div>
  );
};
